import { StatusOption } from "../../types";
import { FileLogStatus } from "shared/types/file";

interface StatusItemProps {
  item: StatusOption;
  onSelect: (value: FileLogStatus) => void;
}

export const StatusItem = ({ item, onSelect }: StatusItemProps) => {
  return (
    <button
      onClick={() => onSelect(item.value)}
      className="w-full text-left p-2 hover:bg-gray-100 rounded-sm"
    >
      {item.label}
    </button>
  );
};